<template>
	<div class="main-top">
		<home-nav></home-nav>
		<!-- Trazilica banner -->
		<section id="index-banner" class="index-banner-area">
			<div class="overlay overlay-bg"></div>
			<div class="container">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 index-banner-content">
						<div class="mt-5 text-center">
							<div id="owl-heading" class="owl-heading owl-carousel owl-theme">
								<div class="item">
									<h1>Pretraži salone</h1>
								</div>
								<div class="item">
									<h1>Rezerviraj termine</h1>
								</div>
								<div class="item">
									<h1>Komentiraj usluge</h1>
								</div>
							</div>
							<h4>Pronađi svoj omiljeni salon i rezerviraj termin online.</h4>
						</div>
						<search></search>
					</div>
				</div>
			</div>
			<nav class="navbar navbar-expand-md main-menu">
				<div class="container">
					<div class="collapse navbar-collapse" id="navbarTogglerDemo02">
						<ul class="navbar-nav nav-fill w-100">
							<li class="nav-item">
								<a class="nav-link" :href="'salon-list?type=frizerski'">Frizerski<span v-if="type == 'frizerski'" class="sr-only">(current)</span></a>
							</li>
							<li class="nav-item">
								<a class="nav-link" :href="'salon-list?type=uljepsavanje'"> Saloni za uljepšavanje <span v-if="type == 'uljepsavanje'" class="sr-only">(current)</span></a>
							</li>
							<li class="nav-item">
								<a class="nav-link" :href="'salon-list?type=masaze'"> Saloni za masažu <span v-if="type == 'masaze'" class="sr-only">(current)</span></a>
							</li>
							<li class="nav-item">
								<a class="nav-link" :href="'salon-list?type=tattoo'"> Tattoo & Piercing <span v-if="type == 'tattoo'" class="sr-only">(current)</span></a>
							</li>
							<li class="nav-item">
								<a class="nav-link" :href="'salon-list?type=spa'"> Spa & Wellness <span v-if="type == 'spa'" class="sr-only">(current)</span></a>
							</li>
							<li class="nav-item">
								<a class="nav-link" :href="'salon-list?type=drugo'"> Drugo <span v-if="type == 'drugo'" class="sr-only">(current)</span></a>
							</li>
						</ul>
					</div>
				</div>
			</nav>
			<div class="container d-md-none mt-3 pb-3">
				<div class="row no-gutters linkovi-container">
					<div class="owl-one owl-carousel owl-theme">
						<div class="nav-item">
							<a class="nav-link" :href="'salon-list?type=frizerski'">Frizerski<span v-if="type == 'frizerski'" class="sr-only">(current)</span></a>
						</div>
						<div class="nav-item">
							<a class="nav-link" :href="'salon-list?type=uljepsavanje'"> Saloni za uljepšavanje <span v-if="type == 'uljepsavanje'" class="sr-only">(current)</span></a>
						</div>
						<div class="nav-item">
							<a class="nav-link" :href="'salon-list?type=masaze'"> Saloni za masažu <span v-if="type == 'masaze'" class="sr-only">(current)</span></a>
						</div>
						<div class="nav-item">
							<a class="nav-link" :href="'salon-list?type=tattoo'"> Tattoo & Piercing <span v-if="type == 'tattoo'" class="sr-only">(current)</span></a>
						</div>
						<div class="nav-item">
							<a class="nav-link" :href="'salon-list?type=spa'"> Spa & Wellness <span v-if="type == 'spa'" class="sr-only">(current)</span></a>
						</div>
						<div class="nav-item">
							<a class="nav-link" :href="'salon-list?type=drugo'"> Drugo <span v-if="type == 'drugo'" class="sr-only">(current)</span></a>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Istaknuti saloni /-->
		<section id="popularni-saloni" class="main-content-area pb-5 pt-md-5">
			<div class="container content-container">
				<div class="row h-100">
					<div class="col-12">
						<div class="mb-3 d-flex">
							<h3 class="section-title mr-auto">ISTAKNUTO</h3>
							<a class="ml-auto dark-color" :href="'salon-list?featured=1'">Prikaži sve</a>
						</div>
					</div>
				</div>
				<div class="row no-gutters owl-container h-100">
					<div id="salonCarol" v-if="!loading" class="active-recent-blog-carusel owl-theme">
						<div v-for="(salon,index) in salons" :key="index" class="single-recent-blog-post item">

							<router-link :to="'/salon/'+salon.name">
								<div class="content-box">
									<!--<div class="img-wrapper">-->
									<div v-bind:style="'background-image:url('+ salon.profile_image +')'" class="img-wrapper">
										<!-- <img src="img/salon.jpg" alt="" class="img-responsive"> -->
										<!-- <h3 class="akcija"><span class="badge badge-danger">AKCIJA!</span></h3> -->
									</div>
									<!--<img :src="salon.profile_image" alt="" class="img-responsive">-->
									<!-- <h3 class="akcija"><span class="badge badge-danger">AKCIJA!</span></h3> -->
									<!-- </div> -->
									<div class="container">
										<div class="row">
											<div class="col-12">
												<div class="index-salon-text">
													<h4>{{salon.name}}</h4>
													<p v-if="salon.address"> {{salon.address.length > 15 ? salon.address.substr(0,15)+'...':salon.address}}, {{salon.city}}</p>
												</div>
											</div>
											<div class="col-12">
												<div class="index-salon-rates">
													<div class="index-salon-stars">
														<span :class="salon.rating >= 1 ? 'fa fa-star checked':'fa fa-star'"></span>
														<span :class="salon.rating >= 2 ? 'fa fa-star checked':'fa fa-star'"></span>
														<span :class="salon.rating >= 3 ? 'fa fa-star checked':'fa fa-star'"></span>
														<span :class="salon.rating >= 4 ? 'fa fa-star checked':'fa fa-star'"></span>
														<span :class="salon.rating == 5 ? 'fa fa-star checked':'fa fa-star'"></span>
													</div>
													<div>
														<small>{{salon.rate_count}}<span> ocjena</span></small>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</router-link>
						</div>
					</div>
					<div style="margin:auto;display:block">
						<loader v-if="loading" color="red"></loader>
					</div>
					<div style="margin:auto;display:block" v-if="!loading && salons.length == 0">Trenutno nema istaknutih salona</div>
				</div>
			</div>
		</section>

		<section id="prize-contest" class="main-content-area pt-3">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-md-5">
						<img class="img-responsive" src="img/frizerka.png">
					</div>
					<div class="col-md-7 mt-5 my-md-0 mb-5">
						<h1 class="title mb-3">Hej, želiš biti dio Figaro priče?</h1>
						<p>Pozivamo te da se besplatno registriraš na našu platformu i tako istakneš svoj salon, privučeš dodatne klijente, smanjiš brigu oko administracije i jednostavno se posvetiš onom što voliš.</p>
						<a class="btn fs-btn dark" href="https://prijava.figaro.hr">Registriraj se</a>
					</div>
				</div>
			</div>
		</section>

		<div v-if="!loading">
			<div v-for="(home_salon,index) in home_salons" :key="index">
				<section id="popularni-saloni" class="main-content-area pb-3 pt-md-3">
					<div class="container content-container">
						<div class="row h-100">
							<div class="col-12">
								<div class="mb-3 d-flex">
									<h3 class="section-title mr-auto">{{home_salon.type}}</h3>
									<a class="ml-auto dark-color">Prikaži sve</a>
								</div>
							</div>
						</div>
						<div class="row no-gutters">
							<div v-for="(salon,index) in home_salon.salon" :key="index" class="col-6 col-md-4 col-lg-3">
								<div v-if="salon.salon_type == home_salon.type">
									
									<router-link :to="'/salon/'+salon.name">
										<div class="content-box">
											<div v-bind:style="'background-image:url('+ salon.profile_image +')'" class="img-wrapper">
											</div>
											<div class="container">
												<div class="row">
													<div class="col-12">
														<div class="index-salon-text">
															<h4>{{salon.name}}</h4>
															<p v-if="salon.address"> {{salon.address.length > 15 ? salon.address.substr(0,15)+'...':salon.address}}, {{salon.city}}</p>
														</div>
													</div>
													<div class="col-12">
														<div class="index-salon-rates">
															<div class="index-salon-stars">
																<span :class="salon.rating >= 1 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="salon.rating >= 2 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="salon.rating >= 3 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="salon.rating >= 4 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="salon.rating == 5 ? 'fa fa-star checked':'fa fa-star'"></span>
															</div>
															<div>
																<small>{{salon.rate_count}}<span> ocjena</span></small>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</router-link>

								</div>
							</div>
							<div style="margin:auto;display:block">
								<loader v-if="loading" color="red"></loader>
							</div>
							<div style="margin:auto;display:block" v-if="!loading && home_salons.length == 0">Trenutno nema istaknutih salona</div>
						</div>
					</div>
				</section>
			</div>
		</div>

		<!--
		<section id="akcije-saloni" class="main-content-area pb-md-5 pt-md-5">
			<div class="container content-container">
				<div class="row h-100">
					<div class="col-12">
						<div class="mb-5">
							<h3 class="float-left section-title py-1 px-2">AKCIJE</h3>
-->
		<!-- <a class="float-right" :href="'salon-list?featured=1'">Prikaži više</a> -->
		<!--
						</div>
					</div>
				</div>

				<div v-if="!loading" class="row no-gutters">
					<div v-for="(service,index) in services" :key="index" class="col-12 col-lg-6">
						<a :href="'/salon/'+service.salon.name">

							<table id="table-frizure" class="table table-sm">
								<tbody>
									<tr>
										<td class="td-img">
											<div v-bind:style="'background-image:url('+ service.profile_image +')'" class="img-service-wrapper"></div>
										</td>
										<td class="td-left">
											<p>{{service.name}}</p>
											<small>{{service.salon.name}}</small>
										</td>
										<td class="text-right pr-lg-3">
											<p>{{service.price}} kn</p>
											<small>{{service.time}} min</small>
										</td>
									</tr>
								</tbody>
							</table>
							<hr>
						</a>
					</div>
				</div>
				<div class="row no-gutters">
					<div style="margin:auto;display:block" v-if="!loading && salons.length == 0">Trenutno nema istaknutih akcija
					</div>
				</div>
			</div>
		</section>
-->
		<!-- poziv na akciju /-->
		<!--
		<section id="sponsors">
			<div class="container content-container">
				<div class="row h-100">
					<div class="col-12">
						<div class="mb-5">
							<h3 class="float-left section-title">PARTNERI</h3>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-sm-4 pb-5 pb-sm-0">
						<img class="img-responsive" src="img/sponzor1.jpg">
					</div>
					<div class="col-12 col-sm-4 pb-5 pb-sm-0">
						<img class="img-responsive" src="img/sponzor2.png">
					</div>
					<div class="col-12 col-sm-4 pb-5 pb-sm-0">
						<img class="img-responsive" src="img/sponzor3.jpg">
					</div>
				</div>
			</div>
		</section>
-->
		<home-footer></home-footer>
	</div>
</template>
<script>
	import search from '../layouts/search';
	import {
		mapState
	} from 'vuex';
	export default {
		name: 'home',
		computed: {
			...mapState({
				salons: (state) => state.featured_salons,
				home_salons: (state) => state.home_salons,
				services: (state) => state.saleServices
			})
		},
		data() {
			return {
				loading: false,
				type: ""
			}
		},
		components: {
			search
		},
		created() {
			this.featuredSalons();
			this.$store.state.home_salons = [];
			this.getSalons('frizerski');
			this.getSalons('uljepsavanje');
			this.getSalons('masaze');
			this.getSalons('drugo');
		},
		methods: {
			featuredSalons() {
				this.loading = true;
				this.$store.dispatch('get', this.$store.state.endpoint + "get-featured-salon")
					.then((data) => {
						data.data = data.data.map((d) => {
							var pimage = d.images.find((d) => d.type == 2);
							d.profile_image = pimage ? pimage.filename : '';
							return d;
						});
						this.$store.state.featured_salons = data.data;

						this.loading = false;
						setTimeout(() => {
							window.$('.active-recent-blog-carusel').owlCarousel({
								nav: false,
								navText: [
									'<i class="fa fa-angle-left" aria-hidden="true"></i>',
									'<i class="fa fa-angle-right" aria-hidden="true"></i>'
								],
								navContainer: '.custom-nav',
								items: 4,
								loop: true,
								margin: 0,
								dots: true,
								autoplayHoverPause: true,
								smartSpeed: 250,
								autoplay: true,
								responsive: {
									0: {
										items: 2,
									},
									576: {
										items: 2,
									},
									768: {
										items: 3,
									},
									992: {
										items: 4,
									},
									1200: {
										items: 5
									},

								}
							});
							// setTimeout(()=>{
							// document.getElementById('salonCarol').style.opacity='1';
							// },500);
						}, 100);
					})
					.catch((error) => {
						console.log(error);
						// this.loading=false;
					})
			},
			getSalons(type) {
				this.loading = true;
				this.$store.dispatch('get', this.$store.state.endpoint + "get-salon-type/" + type)
					.then((data) => {
						data.data = data.data.map((d) => {
							var pimage = d.images.find((d) => d.type == 2);
							d.profile_image = pimage ? pimage.filename : '';
							return d;
						});
						let salons_object = {
							"type":type, 
							"salon": data.data
						};
						this.$store.state.home_salons.push(salons_object);
						this.loading = false;
					})
					.catch((error) => {
						console.log(error);
						this.loading=false;
					})
			},
			saleServices() {
				// document.getElementById('salonCarol').style.opacity='0';
				// this.loading = true;
				this.$store.dispatch('get', this.$store.state.endpoint + "get-sale-services")
					.then((data) => {
						// console.log(data.data);

						data.data = data.data.map((d) => {
							var pimage = d.salon.images.find((d) => d.type == 2);
							d.profile_image = pimage ? pimage.filename : '';
							return d;
						});

						this.$store.state.saleServices = data.data;
						// this.loading = false;
					})
					.catch((error) => {
						console.log(error);
						// this.loading=false;
					})
			}
		}
	}

</script>

<style scoped>
	.td-img {
		width: 60px;
	}

	.img-service-wrapper {
		height: 60px;
		width: 60px;
		background: #dd1d4b21;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
	}

	td {
		border: none;
	}

	@media (max-width: 576px) {

		.td-img {
			display: 60px;
		}

	}

</style>
